import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import commercialBreak from '../store/reducers/commercialBreak';
import { useSelector, useDispatch } from 'react-redux';
import { getCommercialBreakState } from '../store/selectors/commercialBreak';
import CommercialBreak from '../components/CommercialBreak';
import midInningAdEndedAction, { midInningAdStartedAction } from '../store/actions/midInningAdEndedAction';

initContainerData.register({
    reducers: { commercialBreak }
});

const actions = (dispatch) => ({
    adComplete: () => {
        dispatch(midInningAdEndedAction(true));
    },
    adStartedAction: (data) => {
        dispatch(midInningAdStartedAction(data));
    }
});

const CommercialBreakDataContainer = ({
    viewType,
    adId,
    type
}) => {
    const dispatch = useDispatch();
    const { adComplete, adStartedAction } = useMemo(() => actions(dispatch), [dispatch]);
    const { adStarted, transitionFromBreak, transitionToBreak, vidAdsEnabled, adPlayed, midInningAdConfig, adEnded, adType, showMidInnigAd } = useSelector(getCommercialBreakState);

    if (!showMidInnigAd) {
        return null;
    }

    return <CommercialBreak adStarted={adStarted} adStartedAction={adStartedAction} type={type} adId={adId} adType={adType} adEnded={adEnded} adComplete={adComplete} viewType={viewType} transitionFromBreak={transitionFromBreak} transitionToBreak={transitionToBreak} vidAdsEnabled={vidAdsEnabled} adPlayed={adPlayed} midInningAdConfig={midInningAdConfig} />;
};

CommercialBreakDataContainer.propTypes = {
    viewType: PropTypes.string,
    adId: PropTypes.string,
    type: PropTypes.string
};

export default memo(CommercialBreakDataContainer);
